const Logout = () => {
    window.Pelcro.user.logout(() => {
        document.cookie = "swntac=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
        document.cookie = "hasAllAccess=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;";
        window.location.reload();
    });
}

const UserHasAccess = (entitlement_name) => {
    window.Pelcro.user.isEntitledTo(entitlement_name)
}

export default {
    UserHasAccess,
    Logout,
}